import React, { useCallback, useEffect } from "react";
import { useParams } from "react-router-dom";
import Managed, { useManaged } from "../../common/components/Managed";
import api from "../../common/lib/api";
import { InputGroup } from "@blueprintjs/core";
import AsyncButton from "../../common/components/AsyncButton";
import { extractSingleError } from "../../common/components/Errors";

const DEFAULT_STATE = {
    specialPrices: []
};

export default function Page() {
  const [state, setState, setError] = useManaged(DEFAULT_STATE);

  const { companyId } = useParams();

  const load = useCallback(async (companyId) => {
    const {
      data: { data },
    } = await api.get("/companies/item/" + companyId + "/special-prices");

    return { ...data, changed: false };
  }, []);

  const revert = useCallback(() => {
    load(companyId).then(setState, setError);
  }, [load, companyId, setState, setError]);

  const save = useCallback(async () => {
    // eslint-disable-next-line no-restricted-globals
    if (confirm("Are you sure?")) {
      try {
        await api.post("/companies/item/" + companyId + "/special-prices", {
          specialPrices: state.data.specialPrices,
        });
        revert();
      } catch (e) {
        alert(extractSingleError(e));
      }
    }
  }, [companyId, state, revert]);

  useEffect(() => {
    revert();
  }, [revert]);

  const field = (priceIndex, field, type) => {
    return {
      type,
      value: company.specialPrices[priceIndex][field],
      onChange: (e) => {
        const value = e.target.value;
        setState((state) => ({
          ...state,
          specialPrices: state.specialPrices.map((price, index) => {
            if (index === priceIndex) {
              return {
                ...price,
                [field]: value,
              };
            } else {
              return price;
            }
          }),
          changed: true,
        }));
      },
    };
  };

  const company = state.data || {};

  return (
    <Managed state={state}>
      <h1>{company.name}</h1>

      <h2>Special Prices</h2>
      <table className="bp3-html-table bp3-html-table-bordered">
        <thead>
          <tr>
            <th>Item</th>
            <th>If qty &gt;=</th>
            <th>Special price</th>
          </tr>
        </thead>
        <tbody>
          {(company.specialPrices || []).map((price, priceIndex) => {
            return (
              <tr>
                <td>
                  <div class="bp3-html-select .modifier">
                    <select {...field(priceIndex, "saleItemId", "text")}>
                      {company.saleItems.map(([category, items]) => (
                        <optgroup label={category}>
                          {items.map((item) => (
                            <option>{item.saleItemId}</option>
                          ))}
                        </optgroup>
                      ))}
                    </select>
                    <span class="bp3-icon bp3-icon-double-caret-vertical"></span>
                  </div>
                </td>
                <td>
                  <InputGroup {...field(priceIndex, "minQuantity", "number")} />
                </td>
                <td>
                  <InputGroup {...field(priceIndex, "unitPrice", "number")} />
                </td>
                <td>
                  <AsyncButton
                    icon="trash"
                    onClick={() => {
                      setState((state) => ({
                        ...state,
                        specialPrices: state.specialPrices.filter(
                          (_, index) => index !== priceIndex
                        ),
                        changed: true,
                      }));
                    }}
                  >
                    Delete
                  </AsyncButton>
                </td>
              </tr>
            );
          })}
        </tbody>
      </table>
      <p>
        <AsyncButton
          icon="new-object"
          onClick={() => {
            setState((state) => ({
              ...state,
              specialPrices: [
                ...state.specialPrices,
                {
                  saleItemId: "PM45 - 4G",
                  minQuantity: 1,
                  unitPrice: 100,
                },
              ],
              changed: true,
            }));
          }}
        >
          New
        </AsyncButton>
      </p>

      {company.changed && (
        <p>
          <AsyncButton intent="primary" onClick={save}>
            Save
          </AsyncButton>
          <AsyncButton intent="warning" onClick={revert}>
            Revert
          </AsyncButton>
        </p>
      )}
    </Managed>
  );
}
